<template>
  <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
    <div class="close-content"><div @click="onClickCloseDetailView" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
    <article v-if="getTargetOneItem.contents" class="sub-content-wrap">
        <section class="inner-wrap">
            <div class="s-inner-wrap">
              <div class="ibox-title flex-box fl-between ibox-detail-header">
                <span class="info-menu flex-box">
                  <template v-if="getTargetOneItem.contents">{{ reviewOf(getTargetOneItem.date) }}</template>
                </span>
                <span class="info-right">
                </span>
              </div>
              <!-- 1on1-detail1 -->
              <div class="ibox-title detail-head">
                <div class="flex-box cursor">
                  <img v-if="targetContent === 0" class="one-icon" :src="'static/img/1on1/img0' + 1 + '.png'" alt="">
                  <img  v-else-if="targetContent === 1" class="one-icon" :src="'static/img/1on1/img0'+ 2 +'.png'" alt="">
                  <img v-else-if="targetContent === 2" class="one-icon" :src="'static/img/1on1/img0' + 3 + '.png'" alt="">
                  <img v-else class="one-icon" src="static/img/1on1/img05.png" alt="">
                  <div class="comment">
                    <template v-if="targetContent === 0">
                      <h4 class="h3">{{$t('firstContent1on1')}}</h4>
                      <read-more :text="getTargetOneItem.contents[0]" :targetId="this.getTargetOneItemKey + '_0'" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight"> {{getTargetOneItem.contents[0]}} </read-more>
                    </template>
                    <template v-else-if="targetContent === 1">
                      <h4 class="h3">{{$t('secondContent1on1')}}</h4>
                      <read-more :text="getTargetOneItem.contents[1]" :targetId="this.getTargetOneItemKey + '_1'" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight"> {{getTargetOneItem.contents[1]}} </read-more>
                    </template>
                    <template v-else-if="targetContent === 2">
                      <h4 class="h3">{{$t('thirdContent1on1')}}</h4>
                      <read-more :text="getTargetOneItem.contents[2]" :targetId="this.getTargetOneItemKey + '_2'" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight"> {{getTargetOneItem.contents[2]}} </read-more>
                    </template>
                    <template v-else-if="targetContent === 3">
                      <h4 class="h3">{{$t('forthContent1on1')}}</h4>
                      <read-more :text="getTargetOneItem.contents[3]" :targetId="this.getTargetOneItemKey + '_3'" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight"> {{getTargetOneItem.contents[3]}} </read-more>
                    </template>
                    <template v-else>
                      <h4 class="h3">{{$t('memoContent1on1')}}</h4>
                      <read-more :text="getTargetOneItem.memo" :targetId="this.getTargetOneItemKey + '_memo'" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight"> {{getTargetOneItem.memo}} </read-more>
                    </template>
                  </div>
                </div>
              </div>
              <!-- partner -->
              <div v-if="getTargetOneItem.partner" class="ibox-child partner-wrap">
                <div class="row">
                  <div class="form-group col-sm-12 info-status public-detail-status">
                    <label class="control-label status-label" for="status">{{$t('partnerSettingLabelTitle')}}</label>
                    <div class="public-cell">
                      <span class="public-userimg">
                        <img v-if="getPartner.userInfo.userIcon" :src="getPartner.userInfo.userIcon" alt="image" class="img-circle">
                        <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                      </span>
                      <div class="public-userinfo"><span class="public-username">{{ getPartner.userInfo.userName }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- public -->
              <div v-if="this.getTargetType !== '1on1s_memo'" class="ibox-child public-wrap">
                <div class="row">
                  <div class="form-group col-sm-12 info-status public-detail-status">
                    <div class="public-detail">
                      <div>
                        <label class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
                        <span v-if="!getTargetOneItem.limitedAccess">{{$t('allPeopleStrType')}}</span>
                        <span v-else-if="getTargetOneItem.limitedAccess.limitedUsers">{{$t('userBtnTile')}}</span>
                        <span v-else-if="targetLimitedGroups">{{$t('peopleGroupTileType')}}</span>
                        <span v-else-if="targetLimitedOrgs">{{$t('organizationLabelStr')}}</span>
                      </div>
                    </div>
                    <div v-if="getTargetOneItem.limitedAccess && getTargetOneItem.limitedAccess.limitedUsers" class="public-box">
                      <ul>
                        <li v-for="limited in getTargetLimitedUsers" :key="limited.id" class="public-cell">
                          <span class="public-userimg">
                            <img v-if="limited.userInfo.userIcon" :src="limited.userInfo.userIcon" alt="image" class="img-circle">
                            <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                          </span>
                          <div class="public-userinfo"> <span class="public-username">{{limited.userInfo.userName}}</span> </div>
                        </li>
                      </ul>
                    </div>
                    <div class="public-detail">
                      <div v-if="getTargetOneItem.limitedAccess && getTargetOneItem.limitedAccess.limitedUsers && targetLimitedGroups">
                        <label class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
                        <span>{{$t('peopleGroupTileType')}}</span>
                      </div>
                    </div>
                    <div v-if="getTargetOneItem.limitedAccess && targetLimitedGroups" class="public-detail-group">
                      <ul>
                        <li v-for="lgroup in targetLimitedGroups" :key="lgroup.id" class="public-username">
                          <span class="public-username">{{lgroup.groupName}}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="public-detail">
                      <div v-if="getTargetOneItem.limitedAccess && (getTargetOneItem.limitedAccess.limitedUsers || targetLimitedGroups)&& targetLimitedOrgs">
                        <label class="control-label status-label" for="status">{{$t('releaseLabelTitle')}}</label>
                        <span>{{$t('organizationLabelStr')}}</span>
                      </div>
                    </div>
                    <div v-if="targetLimitedOrgs" class="public-detail-group">
                      <ul>
                        <li v-for="(org, key) in targetLimitedOrgs" :key="org.id" class="public-username">
                          <span class="public-username">{{org.groupName}}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!-- public -->
              <div v-if="this.getTargetType !== '1on1s_memo'" class="ib-sub-content">
                <b-tabs>
                  <b-tab :title="$t('commentLabelTitle')">
                    <div class="panel-body">
                      <!-- コメント -->
                      <div v-if="!getTargetComments[0]" class="comment-view ibox-child">{{$t('stillNotCommentStr')}}</div>
                      <div v-else class="comment-view">
                        <div v-for="obj in getTargetComments" :key="obj.id" class="ibox-child" v-if="!obj.parentId">
                          <comment-item @set-reply="setParentCommentId" :propComment="obj"/>
                        </div>
                      </div>
                      <!-- /コメント -->
                    </div>
                  </b-tab>
                  <b-tab :title="$t('niceBtnTitle')">
                      <div v-if="!this.getTargetOneItem.likes ||!this.getTargetOneItem.likes[targetContent]" class="comment-view ibox-child"><span class="comment-text">{{$t('stillNotLikesStr')}}</span></div>
                      <div v-else class="comment-view">
                        <div v-for="(value, key) in getTargetOneItem.likes[targetContent]" :key="value.id" class="ibox-child">
                          <router-link :to="{ name: 'User', params: { userId: key }}">
                            <div class="cursor">
                              <span class="search-userimg">
                                <img v-if="getUserInfoById(key).userIcon" :src="getUserInfoById(key).userIcon" alt="image" class="img-circle">
                                <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                              </span>
                              <div class="search-userinfo">
                                <span class="search-username">{{ getUserInfoById(key).userName }}</span>
                                <span class="search-userdept">{{ getUserInfoById(key).dept }}</span>
                              </div>
                            </div>
                          </router-link>
                        </div>
                      </div>
                  </b-tab>
                </b-tabs>
              </div>
              <!-- </div> -->
              <!-- /1on1-detail -->
            <!-- </div> -->
          </div>
        </section>
        <article v-if="this.getTargetType !== '1on1s_memo'" class="sub-column-comment sub-column-active">
          <section>
            <comment-form @close-event="open = false" ref="setReply" :parentItem="replyParent" :targetId="targetOneItemKey" :target="getTargetType" :userId="getUserId" :targetOwner="getUserId"/>
          </section>
        </article>
    </article>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OneDropDown from '@/components/One/OneDropDown'
import OneItem from '@/components/One/OneItem'
import CommentItem from '@/components/Comment/CommentItem'
import CommentForm from '@/components/Comment/CommentForm'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import { content1on1 } from '@/main'

export default {
  name: 'OneList',
  components: {
    OneDropDown,
    OneItem,
    CommentItem,
    CommentForm,
    ReadMore
  },
  props: ['targetOneItemKey', 'targetContent'],
  data: function () {
    return {
      tag: 'progress',
      open: false,
      targetOneItem: {},
      targetComments: {},
      replyParent: {},
      oneCount: 30,
      propShowMore: false,
      propContentHeight: 0,
      content1on1: content1on1
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'OneList'
    },
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('ones/', [
      'getCurrent1on1s'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId',
      'getIsReadComment',
      'getReadCommentsCount'
    ]),
    ...mapGetters('groups/', [
      'getGroupsByIds'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds',
      'getUserById',
      'getUserInfoById'
    ]),
    contentTitle () {
      return {
        0: this.$t('firstContent1on1'),
        1: this.$t('secondContent1on1'),
        2: this.$t('thirdContent1on1'),
        3: this.$t('forthContent1on1')
      }
    },
    checkContent1on1 () {
      return Object.keys(content1on1.content1on1).length
    },
    getTargetComments () {
      return this.getCommentsByItemId(this.getTargetOneItemKey, this.getTargetType)
    },
    getTargetLikes () {
      return this.getLikesByItemId(this.getTargetOneItemKey, this.getTargetType)
    },
    getTargetOneItemKey () {
      return this.targetOneItemKey
    },
    getTargetType () {
      return '1on1s_' + this.targetContent
    },
    getTargetOneItem () {
      if (this.getCurrent1on1s[this.getTargetOneItemKey]) {
        this.targetOneItem = this.getCurrent1on1s[this.getTargetOneItemKey]
        console.log('targetOneItem =>', this.targetOneItem)
        return this.targetOneItem
      } else {
        console.log('in getTargerOneItem else')
        return {}
      }
    },
    getTargetLimitedUsers () {
      return this.getUsersByIds(Object.keys(this.targetOneItem.limitedAccess.limitedUsers))
    },
    targetLimitedGroups: function () {
      if (this.getTargetOneItem.limitedAccess && this.getTargetOneItem.limitedAccess.limitedGroups) {
        let groups = this.getGroupsByIds(Object.keys(this.getTargetOneItem.limitedAccess.limitedGroups))
        let groupIds = Object.keys(groups).filter(x => !groups[x].isOrganization)
        return groupIds.length > 0 ? this.getGroupsByIds(groupIds) : null
      }
      return null
    },
    targetLimitedOrgs: function () {
      if (this.getTargetOneItem.limitedAccess && this.getTargetOneItem.limitedAccess.limitedGroups) {
        let groups = this.getGroupsByIds(Object.keys(this.getTargetOneItem.limitedAccess.limitedGroups))
        let orgIds = Object.keys(groups).filter(x => groups[x].isOrganization)
        return orgIds.length > 0 ? this.getGroupsByIds(orgIds) : null
      }
      return null
    },
    getPartner () {
      return this.getUserById(this.targetOneItem.partner)
    },
    getCurrent1on1sList () {
      console.log('this.getCurrent1on1s', Object.values(this.getCurrent1on1s)[0])
      if (!Object.values(this.getCurrent1on1s)[0]) {
        console.log('in if')
      } else {
        console.log('in else')
      }
      return this.getCurrent1on1s
    }
  },
  methods: {
    reviewOf: function (date) {
      console.log('reviewOf:', date)
      let ymd = (date || '').split('/')
      let dateFormatted = this.$t('noticeDateFormat')
        .replace('{$y}', (ymd[0] || '----'))
        .replace('{$m}', (ymd[1] || '--'))
        .replace('{$d}', (ymd[2] || '--'))
      return this.$t('retrospectiveStr').replace('{$date}', dateFormatted)
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    },
    openDetailView () {
      this.open = true
    },
    onClickCloseDetailView () {
      this.open = false
      this.$emit('close-detail-view')
    },
    get1on1UnreadCommentKeys (itemType, itemId) {
      const oneCommentsCount = this.getCommentsByItemId(itemId, itemType).filter(x => !x.isDelete).length
      return oneCommentsCount - this.getReadCommentsCount(itemType, this.getUserId, itemId)
    },
    visibilityChanged (isVisible, entry) {
      if (entry.isIntersecting && Number(entry.target.accessKey) === this.oneCount - 1) {
        this.oneCount += 30
        this.$forceUpdate()
      }
    },
    setParentCommentId: function (value) {
      this.replyParent = value
      console.log('setParentCommentId = ', this.replyParent)
      this.$refs.setReply.setContentTextByParent(value.item, value.id)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex-option{
    display: flex;
    flex-direction: column;
  }
  .isExistUnread {
    position: relative;
  }
  .isExistUnread span {
    position: absolute;
    width: 15px;
    height: 15px;
    margin-bottom: 5px;
    right: 0;
    top: -5px;
    color: white;
    display: inline-block;
    background-color: rgba(254,64,56,0.9);
    border-color: red;
    border-width: 2px;
    border-radius: 50%;
    line-height: 15px;
    text-align:center;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/DetailView/OneDetailView.vue